import React from 'react'

export function Menu () {
    return <nav className="nav flex-column">
        <a className="nav-link" href="#">Framework Silicates</a>
        <a className="nav-link" href="#">Sheet Silicates</a>
        <a className="nav-link" href="#">Chain Silicates</a>
        <a className="nav-link" href="#">Disilicates</a>
    </nav>
    }

